module.exports = __webpack_public_path__ + "img/Administracion.5a409b57.svg";